/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInboundAttachmentRequest } from '../models/AcceptInboundAttachmentRequest';
import type { AddClusterMembershipPayload } from '../models/AddClusterMembershipPayload';
import type { AddEntity } from '../models/AddEntity';
import type { AIConceptContextRead } from '../models/AIConceptContextRead';
import type { AIConceptContextUpsert } from '../models/AIConceptContextUpsert';
import type { AIConceptInfo } from '../models/AIConceptInfo';
import type { AssetAccountDocumentRead } from '../models/AssetAccountDocumentRead';
import type { AssignTaskTemplatePayload } from '../models/AssignTaskTemplatePayload';
import type { BlockInterpolationPayload } from '../models/BlockInterpolationPayload';
import type { BulkAcceptInboundAttachmentRequest } from '../models/BulkAcceptInboundAttachmentRequest';
import type { BulkAssignTaskTemplatePayload } from '../models/BulkAssignTaskTemplatePayload';
import type { BulkCreateTimeEntriesPayload } from '../models/BulkCreateTimeEntriesPayload';
import type { BulkDeleteTasksPayload } from '../models/BulkDeleteTasksPayload';
import type { BulkIgnoreInboundAttachmentRequest } from '../models/BulkIgnoreInboundAttachmentRequest';
import type { BulkMarkCompletePayload } from '../models/BulkMarkCompletePayload';
import type { BulkReassignTasksPayload } from '../models/BulkReassignTasksPayload';
import type { BulkSetParentRelationshipsItem } from '../models/BulkSetParentRelationshipsItem';
import type { BulkUpdateDueDatePayload } from '../models/BulkUpdateDueDatePayload';
import type { CashflowExportColumnsResponse } from '../models/CashflowExportColumnsResponse';
import type { CashflowExportRequest } from '../models/CashflowExportRequest';
import type { CashflowExportResponse } from '../models/CashflowExportResponse';
import type { CashflowExportTemplateCreate } from '../models/CashflowExportTemplateCreate';
import type { CashflowExportTemplateRead } from '../models/CashflowExportTemplateRead';
import type { CashflowExternalIdentifierTypeMutate } from '../models/CashflowExternalIdentifierTypeMutate';
import type { CashflowExternalIdentifierTypeWithLedgers } from '../models/CashflowExternalIdentifierTypeWithLedgers';
import type { CashflowFileImportRequest } from '../models/CashflowFileImportRequest';
import type { CashflowLedgerCreateRequest } from '../models/CashflowLedgerCreateRequest';
import type { CashflowLedgerRead } from '../models/CashflowLedgerRead';
import type { CashflowScenarioCreate } from '../models/CashflowScenarioCreate';
import type { CashflowScenarioRead } from '../models/CashflowScenarioRead';
import type { CashflowTagCategoryCreateWithValues } from '../models/CashflowTagCategoryCreateWithValues';
import type { CashflowTagCategoryRead } from '../models/CashflowTagCategoryRead';
import type { CashflowTransactionTypeCreate } from '../models/CashflowTransactionTypeCreate';
import type { CashflowTransactionTypeRead } from '../models/CashflowTransactionTypeRead';
import type { ChartAssistantCancelPayload } from '../models/ChartAssistantCancelPayload';
import type { ChartAssistantPayload } from '../models/ChartAssistantPayload';
import type { ClusterPeriodRangeRead } from '../models/ClusterPeriodRangeRead';
import type { ClusterRead } from '../models/ClusterRead';
import type { CompletedReasonEnum } from '../models/CompletedReasonEnum';
import type { ConvertToAssignablePayload } from '../models/ConvertToAssignablePayload';
import type { ConvertToPeriodicPayload } from '../models/ConvertToPeriodicPayload';
import type { ConvertToStaticPayload } from '../models/ConvertToStaticPayload';
import type { CopiedRichTextPayload } from '../models/CopiedRichTextPayload';
import type { CopiedRichTextResponse } from '../models/CopiedRichTextResponse';
import type { CreateNamespacePayload } from '../models/CreateNamespacePayload';
import type { DashboardRead } from '../models/DashboardRead';
import type { DatabaseRead } from '../models/DatabaseRead';
import type { DatabaseWithRowsAndColumns } from '../models/DatabaseWithRowsAndColumns';
import type { DataExtractionOverview } from '../models/DataExtractionOverview';
import type { DeliverableWithEntitiesWithStatuses } from '../models/DeliverableWithEntitiesWithStatuses';
import type { DocumentGroupCountsForCluster } from '../models/DocumentGroupCountsForCluster';
import type { DocumentGroupCountsPayload } from '../models/DocumentGroupCountsPayload';
import type { DocumentPage } from '../models/DocumentPage';
import type { DocumentParseClientType } from '../models/DocumentParseClientType';
import type { DocumentParseResponseFileOverride } from '../models/DocumentParseResponseFileOverride';
import type { DocumentParseStatus } from '../models/DocumentParseStatus';
import type { DocumentParseStatusResponse } from '../models/DocumentParseStatusResponse';
import type { DocumentTagCountsForCluster } from '../models/DocumentTagCountsForCluster';
import type { DocumentTagRead } from '../models/DocumentTagRead';
import type { EnrichedVisitResponse } from '../models/EnrichedVisitResponse';
import type { EntityComplianceStatuses } from '../models/EntityComplianceStatuses';
import type { EntityFileImportRequest } from '../models/EntityFileImportRequest';
import type { EntityFilter } from '../models/EntityFilter';
import type { EntityFiltersPayload } from '../models/EntityFiltersPayload';
import type { EntityRead } from '../models/EntityRead';
import type { EntitySortPayload } from '../models/EntitySortPayload';
import type { EntityWithParents } from '../models/EntityWithParents';
import type { FavoriteDashboardSummary } from '../models/FavoriteDashboardSummary';
import type { FieldCreatePayload } from '../models/FieldCreatePayload';
import type { FieldDefinition } from '../models/FieldDefinition';
import type { FieldFileImportRequest } from '../models/FieldFileImportRequest';
import type { FieldRead } from '../models/FieldRead';
import type { FieldScenarioCreate } from '../models/FieldScenarioCreate';
import type { FieldScenarioDependencies } from '../models/FieldScenarioDependencies';
import type { FieldScenarioRead } from '../models/FieldScenarioRead';
import type { FieldScenarioUpdate } from '../models/FieldScenarioUpdate';
import type { FileWithUrl_Output } from '../models/FileWithUrl_Output';
import type { FinancialInstitutionWithAssetAccounts } from '../models/FinancialInstitutionWithAssetAccounts';
import type { FlipNamespaceRelationshipPayload } from '../models/FlipNamespaceRelationshipPayload';
import type { FolderTreeNode } from '../models/FolderTreeNode';
import type { FormulaRead } from '../models/FormulaRead';
import type { GridAssistantCancelPayload } from '../models/GridAssistantCancelPayload';
import type { GridAssistantPayload } from '../models/GridAssistantPayload';
import type { IgnoreInboundAttachmentRequest } from '../models/IgnoreInboundAttachmentRequest';
import type { ImportResult } from '../models/ImportResult';
import type { InboundEmailAttachmentRead } from '../models/InboundEmailAttachmentRead';
import type { InboundEmailInboxFilter } from '../models/InboundEmailInboxFilter';
import type { InboundEmailInboxResponse } from '../models/InboundEmailInboxResponse';
import type { InboundEmailPendingCountResponse } from '../models/InboundEmailPendingCountResponse';
import type { IngestionCredentialLinkResponse } from '../models/IngestionCredentialLinkResponse';
import type { IngestionFolderMappingCreate } from '../models/IngestionFolderMappingCreate';
import type { IngestionFolderMappingRead } from '../models/IngestionFolderMappingRead';
import type { IngestionFolderMappingUpdate } from '../models/IngestionFolderMappingUpdate';
import type { IngestionHistoryQuery } from '../models/IngestionHistoryQuery';
import type { IngestionRecordRead } from '../models/IngestionRecordRead';
import type { IngestionSetupRequest } from '../models/IngestionSetupRequest';
import type { IngestionTagMappingCreate } from '../models/IngestionTagMappingCreate';
import type { IngestionTagMappingRead } from '../models/IngestionTagMappingRead';
import type { IngestionTagMappingUpdate } from '../models/IngestionTagMappingUpdate';
import type { IngestionTenantConfigRead } from '../models/IngestionTenantConfigRead';
import type { IngestionTenantConfigUpdate } from '../models/IngestionTenantConfigUpdate';
import type { LensCaptureRead } from '../models/LensCaptureRead';
import type { ListClusterTasksFilters } from '../models/ListClusterTasksFilters';
import type { ListComplianceStatusPayload } from '../models/ListComplianceStatusPayload';
import type { ListDeliverablesWithEntitiesPayload } from '../models/ListDeliverablesWithEntitiesPayload';
import type { ListDocumentsPayload } from '../models/ListDocumentsPayload';
import type { LxAiAssistRequest } from '../models/LxAiAssistRequest';
import type { MemberEntityAccess } from '../models/MemberEntityAccess';
import type { MembershipPeriodRangeRead } from '../models/MembershipPeriodRangeRead';
import type { MembershipRead } from '../models/MembershipRead';
import type { MembershipWithUser } from '../models/MembershipWithUser';
import type { ModifyDatabaseSchemaPayload } from '../models/ModifyDatabaseSchemaPayload';
import type { NamespaceCoverage } from '../models/NamespaceCoverage';
import type { NamespaceFiltersEntry } from '../models/NamespaceFiltersEntry';
import type { NamespaceRead } from '../models/NamespaceRead';
import type { NamespaceWithFeatures } from '../models/NamespaceWithFeatures';
import type { PaginatedClusterTaskSummary } from '../models/PaginatedClusterTaskSummary';
import type { PaginatedResult } from '../models/PaginatedResult';
import type { PaginatedSearchResponse } from '../models/PaginatedSearchResponse';
import type { PeriodTypeEnum } from '../models/PeriodTypeEnum';
import type { PlanNamespaceRelationshipChangesPayload } from '../models/PlanNamespaceRelationshipChangesPayload';
import type { PropertyRead } from '../models/PropertyRead';
import type { ReassignTaskPayload } from '../models/ReassignTaskPayload';
import type { RecentVisitPayload } from '../models/RecentVisitPayload';
import type { RenderableDashboard } from '../models/RenderableDashboard';
import type { RenderableTracebackCell } from '../models/RenderableTracebackCell';
import type { RenderedDashboard } from '../models/RenderedDashboard';
import type { ReorderNamespacesPayload } from '../models/ReorderNamespacesPayload';
import type { ReportCreate } from '../models/ReportCreate';
import type { ReportFontCreate } from '../models/ReportFontCreate';
import type { ReportFontUpdate } from '../models/ReportFontUpdate';
import type { ReportFontWithUrl } from '../models/ReportFontWithUrl';
import type { ReportInstanceSummary } from '../models/ReportInstanceSummary';
import type { ReportRead } from '../models/ReportRead';
import type { ResendInvitationPayload } from '../models/ResendInvitationPayload';
import type { ResetMyEntityFiltersPayload } from '../models/ResetMyEntityFiltersPayload';
import type { RetryAllQuery } from '../models/RetryAllQuery';
import type { RoleAssignmentsCreatePayload } from '../models/RoleAssignmentsCreatePayload';
import type { RoleAssignmentWarning } from '../models/RoleAssignmentWarning';
import type { SheetOverridesRequest } from '../models/SheetOverridesRequest';
import type { TimeEntryCreate } from '../models/TimeEntryCreate';
import type { TimeEntryRead } from '../models/TimeEntryRead';
import type { TimeEntryWithDetails } from '../models/TimeEntryWithDetails';
import type { TimeSeriesModelUpdatePayload } from '../models/TimeSeriesModelUpdatePayload';
import type { Traceback } from '../models/Traceback';
import type { TrackedFieldScenarioRead } from '../models/TrackedFieldScenarioRead';
import type { TrackedPeriodTypeRead } from '../models/TrackedPeriodTypeRead';
import type { TrackedTimeSeriesModelRead } from '../models/TrackedTimeSeriesModelRead';
import type { UpdateClusterLogoPayload } from '../models/UpdateClusterLogoPayload';
import type { UpdateDeliverableNormalizedNamePayload } from '../models/UpdateDeliverableNormalizedNamePayload';
import type { UpdateFieldValuesPayload } from '../models/UpdateFieldValuesPayload';
import type { UpdateMyEntityFiltersPayload } from '../models/UpdateMyEntityFiltersPayload';
import type { UpdateNamespaceHierarchyPayload } from '../models/UpdateNamespaceHierarchyPayload';
import type { UpdateNamespaceRelationshipCardinalityPayload } from '../models/UpdateNamespaceRelationshipCardinalityPayload';
import type { UpsertClusterPeriodDateRangePayload } from '../models/UpsertClusterPeriodDateRangePayload';
import type { UpsertMyPeriodDateRangePayload } from '../models/UpsertMyPeriodDateRangePayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClustersService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Entity And Cluster Memberships For Cluster
     * @param clusterId
     * @returns MembershipWithUser Successful Response
     * @throws ApiError
     */
    public listEntityAndClusterMembershipsForCluster(
        clusterId: string,
    ): CancelablePromise<Array<MembershipWithUser>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-entity-and-cluster-memberships-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Entities
     * @param clusterId
     * @returns EntityRead Successful Response
     * @throws ApiError
     */
    public listEntities(
        clusterId: string,
    ): CancelablePromise<Array<EntityRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-entities',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cluster Memberships With Users
     * @param clusterId
     * @param withStaff
     * @returns MembershipWithUser Successful Response
     * @throws ApiError
     */
    public listClusterMembershipsWithUsers(
        clusterId: string,
        withStaff: boolean = true,
    ): CancelablePromise<Array<MembershipWithUser>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-memberships',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'with_staff': withStaff,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cluster
     * @param clusterId
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public getCluster(
        clusterId: string,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/get-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reorder Namespaces
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public reorderNamespaces(
        clusterId: string,
        requestBody: ReorderNamespacesPayload,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/reorder-namespaces',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Namespace Hierarchy
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public updateNamespaceHierarchy(
        clusterId: string,
        requestBody: UpdateNamespaceHierarchyPayload,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clusters/{cluster_id}/namespace-hierarchy',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Namespace Relationship Cardinality
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public updateNamespaceRelationshipCardinality(
        clusterId: string,
        requestBody: UpdateNamespaceRelationshipCardinalityPayload,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clusters/{cluster_id}/namespace-relationship-cardinality',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Flip Namespace Relationship
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public flipNamespaceRelationship(
        clusterId: string,
        requestBody: FlipNamespaceRelationshipPayload,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/flip-namespace-relationship',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Plan Namespace Relationship Changes
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public planNamespaceRelationshipChanges(
        clusterId: string,
        requestBody: PlanNamespaceRelationshipChangesPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/namespace-relationship-plan',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Apply Namespace Relationship Changes
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public applyNamespaceRelationshipChanges(
        clusterId: string,
        requestBody: PlanNamespaceRelationshipChangesPayload,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/apply-namespace-relationship-plan',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Cluster Logo
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public updateClusterLogo(
        clusterId: string,
        requestBody: UpdateClusterLogoPayload,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/update-cluster-logo',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Namespace Entity Filters
     * Atomic save of multiple namespaces' entity filters in one request — used by
     * the settings UI so a flaky network can't leave the cluster in a half-saved state.
     *
     * Authorization: any cluster member with read access can edit namespace
     * defaults. This is a deliberate choice — namespace defaults are treated as a
     * shared workspace setting that any collaborator can adjust, and personal
     * overrides (`update-my-entity-filters`) provide an escape hatch for users
     * who disagree. Revisit if/when product wants admin-only gating; at that
     * point swap `ClusterReadGuard` for the admin guard.
     * @param clusterId
     * @param requestBody
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public updateNamespaceEntityFilters(
        clusterId: string,
        requestBody: Array<NamespaceFiltersEntry>,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/update-namespace-entity-filters',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update My Entity Filters
     * Save (or clear) the calling user's personal-tier filter block.
     *
     * `payload.tier` discriminates between `"namespace"` (the per-user, per-namespace
     * default that applies across every page on that namespace) and `"page"`
     * (the surface-specific override). For `tier="namespace"`, set
     * `namespace_id`; for `tier="page"`, set `scope_key` (the frontend
     * constructs scope keys as `'<surface>:<id>'` — backend treats them as
     * opaque strings). A `payload.block=None` clears the row at that tier.
     *
     * Authorization scopes the write to the calling user's own membership, so
     * a forged scope_key cannot affect another user.
     * @param clusterId
     * @param requestBody
     * @returns MembershipRead Successful Response
     * @throws ApiError
     */
    public updateMyEntityFilters(
        clusterId: string,
        requestBody: UpdateMyEntityFiltersPayload,
    ): CancelablePromise<MembershipRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/update-my-entity-filters',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reset My Entity Filters
     * Drop the calling user's personal-tier filter block.
     *
     * See `update_my_entity_filters` for tier semantics.
     * @param clusterId
     * @param requestBody
     * @returns MembershipRead Successful Response
     * @throws ApiError
     */
    public resetMyEntityFilters(
        clusterId: string,
        requestBody: ResetMyEntityFiltersPayload,
    ): CancelablePromise<MembershipRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/reset-my-entity-filters',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Namespaces
     * @param clusterId
     * @returns NamespaceRead Successful Response
     * @throws ApiError
     */
    public listNamespaces(
        clusterId: string,
    ): CancelablePromise<Array<NamespaceRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-namespaces',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Namespaces With Features
     * @param clusterId
     * @returns NamespaceWithFeatures Successful Response
     * @throws ApiError
     */
    public listNamespacesWithFeatures(
        clusterId: string,
    ): CancelablePromise<Array<NamespaceWithFeatures>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-namespaces-with-features',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Namespace
     * Create a new namespace with hierarchy relationships.
     *
     * Staff-only endpoint to add a namespace with specified parent and child relationships.
     * All relationships use single cardinality. Features may be provided explicitly;
     * otherwise the namespace defaults to the entity registry baseline.
     * @param clusterId
     * @param requestBody
     * @returns NamespaceRead Successful Response
     * @throws ApiError
     */
    public createNamespace(
        clusterId: string,
        requestBody: CreateNamespacePayload,
    ): CancelablePromise<NamespaceRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/namespaces',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cluster Tracked Period Types
     * @param clusterId
     * @returns TrackedPeriodTypeRead Successful Response
     * @throws ApiError
     */
    public listClusterTrackedPeriodTypes(
        clusterId: string,
    ): CancelablePromise<Array<TrackedPeriodTypeRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-cluster-period-types',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Cluster Default Period Type
     * @param clusterId
     * @param periodType
     * @returns any Successful Response
     * @throws ApiError
     */
    public setClusterDefaultPeriodType(
        clusterId: string,
        periodType: PeriodTypeEnum,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/set-default-period-type',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'period_type': periodType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get My Period Date Range
     * The caller's saved range for a surface + period type, or ``null`` if unset
     * (the frontend then uses the cluster default or its computed default). Callers
     * without a membership row (e.g. staff, who pass the read guard without one)
     * also get ``null`` — 404 is reserved for the write endpoints, so routine page
     * loads by such users don't register as errors.
     * @param clusterId
     * @param scopeKey
     * @param periodType
     * @returns any Successful Response
     * @throws ApiError
     */
    public getMyPeriodDateRange(
        clusterId: string,
        scopeKey: string,
        periodType: PeriodTypeEnum,
    ): CancelablePromise<(MembershipPeriodRangeRead | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/my-period-date-range',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'scope_key': scopeKey,
                'period_type': periodType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upsert My Period Date Range
     * Save (upsert) the caller's range. Authorization scopes the write to the
     * caller's own membership, so a forged `scope_key` cannot affect another user.
     * @param clusterId
     * @param requestBody
     * @returns MembershipPeriodRangeRead Successful Response
     * @throws ApiError
     */
    public upsertMyPeriodDateRange(
        clusterId: string,
        requestBody: UpsertMyPeriodDateRangePayload,
    ): CancelablePromise<MembershipPeriodRangeRead> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clusters/{cluster_id}/my-period-date-range',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete My Period Date Range
     * Clear the caller's saved range so they fall back to the cluster default /
     * computed default. Scoped to the caller's own membership.
     * @param clusterId
     * @param scopeKey
     * @param periodType
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteMyPeriodDateRange(
        clusterId: string,
        scopeKey: string,
        periodType: PeriodTypeEnum,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/my-period-date-range',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'scope_key': scopeKey,
                'period_type': periodType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cluster Period Date Range
     * The cluster-wide default range for a surface + period type, or ``null`` if
     * unset. Any cluster member can read it.
     * @param clusterId
     * @param scopeKey
     * @param periodType
     * @returns any Successful Response
     * @throws ApiError
     */
    public getClusterPeriodDateRange(
        clusterId: string,
        scopeKey: string,
        periodType: PeriodTypeEnum,
    ): CancelablePromise<(ClusterPeriodRangeRead | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cluster-period-date-range',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'scope_key': scopeKey,
                'period_type': periodType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upsert Cluster Period Date Range
     * Set (upsert) the cluster-wide default range for a surface + period type.
     * Cluster-admin only (``ClusterAdminGuard``).
     * @param clusterId
     * @param requestBody
     * @returns ClusterPeriodRangeRead Successful Response
     * @throws ApiError
     */
    public upsertClusterPeriodDateRange(
        clusterId: string,
        requestBody: UpsertClusterPeriodDateRangePayload,
    ): CancelablePromise<ClusterPeriodRangeRead> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clusters/{cluster_id}/cluster-period-date-range',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Cluster Period Date Range
     * Clear the cluster-wide default range for a surface + period type.
     * Cluster-admin only (``ClusterAdminGuard``).
     * @param clusterId
     * @param scopeKey
     * @param periodType
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteClusterPeriodDateRange(
        clusterId: string,
        scopeKey: string,
        periodType: PeriodTypeEnum,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/cluster-period-date-range',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'scope_key': scopeKey,
                'period_type': periodType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Potential Parent Entities For Namespace
     * @param clusterId
     * @param namespaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public listPotentialParentEntitiesForNamespace(
        clusterId: string,
        namespaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-potential-parent-entities-for-namespace',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cluster Namespace
     * @param clusterId
     * @returns NamespaceRead Successful Response
     * @throws ApiError
     */
    public getClusterNamespace(
        clusterId: string,
    ): CancelablePromise<NamespaceRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}get-cluster-namespace-id',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Import Fields
     * Get field definitions for entity imports.
     *
     * Returns field schema for import modal including core fields, parent entity fields, and reference fields.
     * @param clusterId
     * @param namespaceId
     * @returns FieldDefinition Successful Response
     * @throws ApiError
     */
    public getEntityImportFields(
        clusterId: string,
        namespaceId: string,
    ): CancelablePromise<Array<FieldDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/namespaces/{namespace_id}/import/fields',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List All Parent Entities Grouped By Namespace
     * Get a dictionary of entity_id -> list of parent entities for all entities in the given cluster.
     * Returns all parent entities across all namespaces for each entity.
     * @param clusterId
     * @returns EntityRead Successful Response
     * @throws ApiError
     */
    public listAllParentEntitiesGroupedByNamespace(
        clusterId: string,
    ): CancelablePromise<Record<string, Record<string, Array<EntityRead>>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/list-all-parent-entities-grouped-by-namespace',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Relationship Graph
     * Generates an entity relationship graph for all namespaces in the cluster.
     * This creates a mapping that allows the UI to filter entities based on their relationships.
     *
     * Returns a dictionary where each namespace maps to entities, and each entity maps to
     * a list of all related entities across other namespaces. This enables cascading filtering
     * where selecting entities progressively narrows choices in other namespaces.
     * @param clusterId
     * @returns string Successful Response
     * @throws ApiError
     */
    public getEntityRelationshipGraph(
        clusterId: string,
    ): CancelablePromise<Record<string, Record<string, Array<string>>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/get-entity-relationship-graph',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Set Parent Relationships
     * Batch update parent relationships for multiple entities.
     * Each item specifies an entity, a parent namespace, and the desired parent entity IDs.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkSetParentRelationships(
        clusterId: string,
        requestBody: Array<BulkSetParentRelationshipsItem>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clusters/{cluster_id}/bulk-relationships',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Unique Task Names For Cluster
     * Get all unique task names for cluster tasks across all namespaces.
     * @param clusterId
     * @returns string Successful Response
     * @throws ApiError
     */
    public listUniqueTaskNamesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/collection-plans/list-unique-task-names-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cluster Tasks
     * @param clusterId
     * @param sortBy
     * @param sortOrder
     * @param page
     * @param pageSize
     * @param requestBody
     * @returns PaginatedClusterTaskSummary Successful Response
     * @throws ApiError
     */
    public listClusterTasks(
        clusterId: string,
        sortBy: string = 'effective_date',
        sortOrder: string = 'desc',
        page: number = 1,
        pageSize: number = 50,
        requestBody?: (ListClusterTasksFilters | null),
    ): CancelablePromise<PaginatedClusterTaskSummary> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/list-cluster-tasks',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'page': page,
                'page_size': pageSize,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Task
     * @param clusterId
     * @param taskId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteTask(
        clusterId: string,
        taskId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/collection-plans/delete-task/{task_id}',
            path: {
                'cluster_id': clusterId,
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Mark Task Complete
     * Called when a Cluster marks a task as complete without submitting data
     * @param clusterId
     * @param taskId
     * @param completedReason
     * @returns any Successful Response
     * @throws ApiError
     */
    public markTaskComplete(
        clusterId: string,
        taskId: string,
        completedReason?: (CompletedReasonEnum | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/collection-plans/mark-task-complete/{task_id}',
            path: {
                'cluster_id': clusterId,
                'task_id': taskId,
            },
            query: {
                'completed_reason': completedReason,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reassign Task
     * Reassign a task to different users
     * @param clusterId
     * @param taskId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public reassignTask(
        clusterId: string,
        taskId: string,
        requestBody: ReassignTaskPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/collection-plans/reassign-task/{task_id}',
            path: {
                'cluster_id': clusterId,
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Reassign Tasks
     * Bulk reassign multiple tasks to different users
     * @param clusterId
     * @param taskId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkReassignTasks(
        clusterId: string,
        taskId: string,
        requestBody: BulkReassignTasksPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/bulk-reassign-tasks',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Update Due Dates
     * Bulk update due dates for multiple tasks
     * @param clusterId
     * @param taskId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkUpdateDueDates(
        clusterId: string,
        taskId: string,
        requestBody: BulkUpdateDueDatePayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/bulk-update-due-dates',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Mark Complete
     * Bulk mark multiple tasks as complete
     * @param clusterId
     * @param taskId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkMarkComplete(
        clusterId: string,
        taskId: string,
        requestBody: BulkMarkCompletePayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/bulk-mark-complete',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Delete Tasks
     * Bulk delete multiple tasks
     * @param clusterId
     * @param taskId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkDeleteTasks(
        clusterId: string,
        taskId: string,
        requestBody: BulkDeleteTasksPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/bulk-delete-tasks',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cluster Interpolated Body By Block Id
     * @param clusterId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public getClusterInterpolatedBodyByBlockId(
        clusterId: string,
        requestBody: BlockInterpolationPayload,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/get-cluster-interpolated-body-by-block',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Compliance Statuses For Entities
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns EntityComplianceStatuses Successful Response
     * @throws ApiError
     */
    public listComplianceStatusesForEntities(
        clusterId: string,
        namespaceId: string,
        requestBody: ListComplianceStatusPayload,
    ): CancelablePromise<Array<EntityComplianceStatuses>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/list-compliance-statuses-for-entities',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Compliance Statuses For Entities
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public exportComplianceStatusesForEntities(
        clusterId: string,
        namespaceId: string,
        requestBody: ListComplianceStatusPayload,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/export-compliance-statuses-for-entities',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Deliverables With Entities With Statuses
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns DeliverableWithEntitiesWithStatuses Successful Response
     * @throws ApiError
     */
    public listDeliverablesWithEntitiesWithStatuses(
        clusterId: string,
        namespaceId: string,
        requestBody: ListDeliverablesWithEntitiesPayload,
    ): CancelablePromise<Array<DeliverableWithEntitiesWithStatuses>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/list-deliverables-with-entities-with-statuses',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Compliance Statuses For Deliverables
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public exportComplianceStatusesForDeliverables(
        clusterId: string,
        namespaceId: string,
        requestBody: ListDeliverablesWithEntitiesPayload,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/export-compliance-statuses-for-deliverables',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Deliverable Normalized Name
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateDeliverableNormalizedName(
        clusterId: string,
        requestBody: UpdateDeliverableNormalizedNamePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/collection-plans/update-deliverable-normalized-name/',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Audit Logs For Deliverables For Cluster
     * @param clusterId
     * @param cursor
     * @param pageSize
     * @returns PaginatedResult Successful Response
     * @throws ApiError
     */
    public listAuditLogsForDeliverablesForCluster(
        clusterId: string,
        cursor?: (string | null),
        pageSize: number = 20,
    ): CancelablePromise<PaginatedResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/collection-plans/list-audit-logs-for-deliverables-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'cursor': cursor,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Fields For Cluster
     * @param clusterId
     * @param includesTsm
     * @returns FieldRead Successful Response
     * @throws ApiError
     */
    public listFieldsForCluster(
        clusterId: string,
        includesTsm: boolean = false,
    ): CancelablePromise<Array<FieldRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/properties/list-fields-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'includes_tsm': includesTsm,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Formulas For Cluster
     * @param clusterId
     * @returns FormulaRead Successful Response
     * @throws ApiError
     */
    public listFormulasForCluster(
        clusterId: string,
    ): CancelablePromise<Array<FormulaRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/properties/list-formulas-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Properties For Cluster
     * @param clusterId
     * @returns PropertyRead Successful Response
     * @throws ApiError
     */
    public listPropertiesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<PropertyRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/properties/list-properties-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Ai Assist Lx
     * Lu - AI assistant for generating Lx expressions.
     *
     * Uses agent architecture with:
     * - Orchestrator focused on workflow and coordination
     * - Tools encapsulate domain knowledge
     * - Property search with semantic understanding
     *
     * Returns immediately and streams response via WebSocket on 'LU' channel.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public aiAssistLx(
        clusterId: string,
        requestBody: LxAiAssistRequest,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/properties/ai-assist-lx',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Document Tags For Cluster
     * @param clusterId
     * @returns DocumentTagRead Successful Response
     * @throws ApiError
     */
    public listDocumentTagsForCluster(
        clusterId: string,
    ): CancelablePromise<Record<string, Array<DocumentTagRead>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/document-tags/list-document-tags-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Field For Cluster
     * @param clusterId
     * @param requestBody
     * @returns FieldRead Successful Response
     * @throws ApiError
     */
    public createFieldForCluster(
        clusterId: string,
        requestBody: FieldCreatePayload,
    ): CancelablePromise<FieldRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/create-field-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Field Scenario For Cluster
     * @param clusterId
     * @param requestBody
     * @returns FieldScenarioRead Successful Response
     * @throws ApiError
     */
    public createFieldScenarioForCluster(
        clusterId: string,
        requestBody: FieldScenarioCreate,
    ): CancelablePromise<FieldScenarioRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/create-field-scenario-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create And Track Scenario For Namespace
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns FieldScenarioRead Successful Response
     * @throws ApiError
     */
    public createAndTrackScenarioForNamespace(
        clusterId: string,
        namespaceId: string,
        requestBody: FieldScenarioCreate,
    ): CancelablePromise<FieldScenarioRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/create-and-track-scenario-for-namespace',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Field Scenario For Cluster
     * @param clusterId
     * @param fieldScenarioId
     * @param requestBody
     * @returns FieldScenarioRead Successful Response
     * @throws ApiError
     */
    public updateFieldScenarioForCluster(
        clusterId: string,
        fieldScenarioId: string,
        requestBody: FieldScenarioUpdate,
    ): CancelablePromise<FieldScenarioRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/update-field-scenario-for-cluster/{field_scenario_id}',
            path: {
                'cluster_id': clusterId,
                'field_scenario_id': fieldScenarioId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Tracked Field Scenarios For Cluster
     * @param clusterId
     * @returns TrackedFieldScenarioRead Successful Response
     * @throws ApiError
     */
    public listTrackedFieldScenariosForCluster(
        clusterId: string,
    ): CancelablePromise<Array<TrackedFieldScenarioRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/list-field-scenarios-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Field Scenario Dependencies For Cluster
     * @param clusterId
     * @param fieldScenarioId
     * @returns FieldScenarioDependencies Successful Response
     * @throws ApiError
     */
    public getFieldScenarioDependenciesForCluster(
        clusterId: string,
        fieldScenarioId: string,
    ): CancelablePromise<FieldScenarioDependencies> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/fields/field-scenario-dependencies/{field_scenario_id}',
            path: {
                'cluster_id': clusterId,
                'field_scenario_id': fieldScenarioId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Field Scenario For Cluster
     * @param clusterId
     * @param fieldScenarioId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteFieldScenarioForCluster(
        clusterId: string,
        fieldScenarioId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/fields/delete-field-scenario/{field_scenario_id}',
            path: {
                'cluster_id': clusterId,
                'field_scenario_id': fieldScenarioId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Default Field Scenario For Cluster
     * @param clusterId
     * @param fieldScenarioId
     * @returns FieldScenarioRead Successful Response
     * @throws ApiError
     */
    public setDefaultFieldScenarioForCluster(
        clusterId: string,
        fieldScenarioId: string,
    ): CancelablePromise<FieldScenarioRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/set-default-field-scenario/{field_scenario_id}',
            path: {
                'cluster_id': clusterId,
                'field_scenario_id': fieldScenarioId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Stop Tracking Field Scenario For Namespace
     * @param clusterId
     * @param namespaceId
     * @param fieldScenarioId
     * @returns any Successful Response
     * @throws ApiError
     */
    public stopTrackingFieldScenarioForNamespace(
        clusterId: string,
        namespaceId: string,
        fieldScenarioId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/fields/stop-tracking-field-scenario-for-namespace/{namespace_id}/{field_scenario_id}',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
                'field_scenario_id': fieldScenarioId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Convert Field To Global
     * Convert an assignable field to a global field.
     * This will remove all entity assignments and make the field available to all entities.
     * @param clusterId
     * @param fieldId
     * @returns FieldRead Successful Response
     * @throws ApiError
     */
    public convertFieldToGlobal(
        clusterId: string,
        fieldId: string,
    ): CancelablePromise<FieldRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/convert-field-to-global/{field_id}',
            path: {
                'cluster_id': clusterId,
                'field_id': fieldId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Convert Field To Periodic
     * Convert a static field to periodic, stamping its values onto the chosen period and date.
     * @param clusterId
     * @param fieldId
     * @param requestBody
     * @returns FieldRead Successful Response
     * @throws ApiError
     */
    public convertFieldToPeriodic(
        clusterId: string,
        fieldId: string,
        requestBody: ConvertToPeriodicPayload,
    ): CancelablePromise<FieldRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/convert-field-to-periodic/{field_id}',
            path: {
                'cluster_id': clusterId,
                'field_id': fieldId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Convert Field To Static
     * Convert a periodic field to static, collapsing each entity to a single value.
     * @param clusterId
     * @param fieldId
     * @param requestBody
     * @returns FieldRead Successful Response
     * @throws ApiError
     */
    public convertFieldToStatic(
        clusterId: string,
        fieldId: string,
        requestBody: ConvertToStaticPayload,
    ): CancelablePromise<FieldRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/convert-field-to-static/{field_id}',
            path: {
                'cluster_id': clusterId,
                'field_id': fieldId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Convert Field To Assignable
     * Convert a global field to an assignable field and assign it to the specified entities.
     * @param clusterId
     * @param fieldId
     * @param requestBody
     * @returns FieldRead Successful Response
     * @throws ApiError
     */
    public convertFieldToAssignable(
        clusterId: string,
        fieldId: string,
        requestBody: ConvertToAssignablePayload,
    ): CancelablePromise<FieldRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/convert-field-to-assignable/{field_id}',
            path: {
                'cluster_id': clusterId,
                'field_id': fieldId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Convert Formula To Global
     * Convert an assignable formula to a global formula.
     * This will remove all entity assignments and make the formula available to all entities.
     * @param clusterId
     * @param formulaId
     * @returns FormulaRead Successful Response
     * @throws ApiError
     */
    public convertFormulaToGlobal(
        clusterId: string,
        formulaId: string,
    ): CancelablePromise<FormulaRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/convert-formula-to-global/{formula_id}',
            path: {
                'cluster_id': clusterId,
                'formula_id': formulaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Convert Formula To Assignable
     * Convert a global formula to an assignable formula and assign it to the specified entities.
     * @param clusterId
     * @param formulaId
     * @param requestBody
     * @returns FormulaRead Successful Response
     * @throws ApiError
     */
    public convertFormulaToAssignable(
        clusterId: string,
        formulaId: string,
        requestBody: ConvertToAssignablePayload,
    ): CancelablePromise<FormulaRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/convert-formula-to-assignable/{formula_id}',
            path: {
                'cluster_id': clusterId,
                'formula_id': formulaId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Field Import Fields
     * Get field definitions for field/formula imports.
     *
     * This endpoint provides the schema for the import modal:
     * - Core fields (name, description, returnType, expression)
     * - Field configuration (isTemporal, aggregationType)
     * - Scope configuration (scope, assignedEntities)
     * - Organization (fieldGroup with dynamic field groups)
     * - Select field options
     *
     * Frontend uses this to build the field mapping UI dynamically.
     *
     * Returns:
     * List of field definitions with keys, labels, types, and requirements
     * @param clusterId
     * @param namespaceId
     * @returns FieldDefinition Successful Response
     * @throws ApiError
     */
    public getFieldImportFields(
        clusterId: string,
        namespaceId: string,
    ): CancelablePromise<Array<FieldDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/fields/get-field-import-fields/{namespace_id}',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Field Value Import Fields
     * Get field definitions for field VALUE imports.
     *
     * This endpoint provides the schema for importing field values:
     * - entity_name: Entity to import values for
     * - field_name: Field to set values on
     * - value: The value to import
     * - effective_date: Date the value is effective
     * - period_type: Period type tracked for the namespace
     * - scenario_name: Optional scenario (defaults to Actuals)
     * - as_of_date: Optional - controls restatement vs correction behavior
     *
     * Returns:
     * List of field definitions with keys, labels, types, and requirements
     * @param clusterId
     * @param namespaceId
     * @returns FieldDefinition Successful Response
     * @throws ApiError
     */
    public getFieldValueImportFields(
        clusterId: string,
        namespaceId: string,
    ): CancelablePromise<Array<FieldDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/fields/get-field-value-import-fields/{namespace_id}',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Import Fields From File
     * Import fields and formulas from file data (CSV, Excel) uploaded via the UI.
     *
     * This endpoint:
     * - Receives mapped data from the frontend ImportModal
     * - Validates all rows and collects errors
     * - Determines field vs formula based on expression presence
     * - Only persists to database if no errors OR skip_validation_errors=True
     *
     * Args:
     * cluster_id: Cluster ID (from auth guard)
     * namespace_id: Target namespace for fields/formulas
     * request: Import request containing data and options
     *
     * Returns:
     * ImportResult with status, counts, and any errors
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns ImportResult Successful Response
     * @throws ApiError
     */
    public importFieldsFromFile(
        clusterId: string,
        namespaceId: string,
        requestBody: FieldFileImportRequest,
    ): CancelablePromise<ImportResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/fields/namespaces/{namespace_id}/import-fields-from-file',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Institutions With Asset Accounts By Entity Id
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns FinancialInstitutionWithAssetAccounts Successful Response
     * @throws ApiError
     */
    public listInstitutionsWithAssetAccountsByEntityId(
        clusterId: string,
        namespaceId: string,
        requestBody: EntityFiltersPayload,
    ): CancelablePromise<Record<string, Array<FinancialInstitutionWithAssetAccounts>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/asset-accounts/list-institutions-with-asset-accounts-by-entity-id',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Balances For Cluster
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public exportBalancesForCluster(
        clusterId: string,
        namespaceId: string,
        requestBody: EntityFiltersPayload,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/asset-accounts/export-balances-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Asset Account Documents For Cluster
     * @param clusterId
     * @returns AssetAccountDocumentRead Successful Response
     * @throws ApiError
     */
    public listAssetAccountDocumentsForCluster(
        clusterId: string,
    ): CancelablePromise<Array<AssetAccountDocumentRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/asset-accounts/list-asset-account-documents-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Documents For Cluster Paginated
     * @param clusterId
     * @param page
     * @param pageSize
     * @param sortBy
     * @param sortOrder
     * @param requestBody
     * @returns DocumentPage Successful Response
     * @throws ApiError
     */
    public listDocumentsForClusterPaginated(
        clusterId: string,
        page: number = 1,
        pageSize: number = 50,
        sortBy?: (string | null),
        sortOrder: 'asc' | 'desc' = 'desc',
        requestBody?: (ListDocumentsPayload | null),
    ): CancelablePromise<DocumentPage> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/documents/list-documents-for-cluster-paginated',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'page': page,
                'page_size': pageSize,
                'sort_by': sortBy,
                'sort_order': sortOrder,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Document Tag Counts For Cluster
     * @param clusterId
     * @param requestBody
     * @returns DocumentTagCountsForCluster Successful Response
     * @throws ApiError
     */
    public listDocumentTagCountsForCluster(
        clusterId: string,
        requestBody?: (ListDocumentsPayload | null),
    ): CancelablePromise<DocumentTagCountsForCluster> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/documents/list-document-tag-counts-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Document Group Counts For Cluster
     * @param clusterId
     * @param requestBody
     * @returns DocumentGroupCountsForCluster Successful Response
     * @throws ApiError
     */
    public listDocumentGroupCountsForCluster(
        clusterId: string,
        requestBody: DocumentGroupCountsPayload,
    ): CancelablePromise<DocumentGroupCountsForCluster> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/documents/list-document-group-counts-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Copy Documents To Entity
     * @param clusterId
     * @param sourceEntityId
     * @param targetEntityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public copyDocumentsToEntity(
        clusterId: string,
        sourceEntityId: string,
        targetEntityId: string,
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/documents/copy-documents-to-entity',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'source_entity_id': sourceEntityId,
                'target_entity_id': targetEntityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Audit Logs For Documents For Cluster
     * @param clusterId
     * @param cursor
     * @param pageSize
     * @returns PaginatedResult Successful Response
     * @throws ApiError
     */
    public listAuditLogsForDocumentsForCluster(
        clusterId: string,
        cursor?: (string | null),
        pageSize: number = 20,
    ): CancelablePromise<PaginatedResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/documents/list-audit-logs-for-documents-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'cursor': cursor,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Parse Document
     * Parse document with smart deduplication. Returns existing parse if available, otherwise starts new parse.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * document_id: ID of the document to parse
     * sheets: Optional list of sheet names to parse (for selective parsing of large files)
     * metadata_only: If True, return metadata only (describe mode) instead of full parse
     * parse_service: Optional document parse service
     *
     * Returns:
     * DocumentParseStatusResponse with parse status
     *
     * Raises:
     * 404: Document not found
     * 422: Document cannot be parsed
     * @param clusterId
     * @param documentId
     * @param sheets Optional list of sheet names to parse (case-sensitive)
     * @param metadataOnly Return metadata only (fast describe mode)
     * @returns DocumentParseStatusResponse Successful Response
     * @throws ApiError
     */
    public parseDocument(
        clusterId: string,
        documentId: string,
        sheets?: (Array<string> | null),
        metadataOnly: boolean = false,
    ): CancelablePromise<DocumentParseStatusResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/document-parse/parse-document/{document_id}',
            path: {
                'cluster_id': clusterId,
                'document_id': documentId,
            },
            query: {
                'sheets': sheets,
                'metadata_only': metadataOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Parse Status
     * Get the status of a document parse.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * parse_id: ID of the parse record
     * parse_service: DocumentParseService
     *
     * Returns:
     * DocumentParseStatusResponse with current status
     * @param clusterId
     * @param parseId
     * @returns DocumentParseStatusResponse Successful Response
     * @throws ApiError
     */
    public getParseStatus(
        clusterId: string,
        parseId: string,
    ): CancelablePromise<DocumentParseStatusResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/document-parse/parse-status/{parse_id}',
            path: {
                'cluster_id': clusterId,
                'parse_id': parseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Cancel Parse
     * Cancel any in-progress parse(s) for the document.
     *
     * Marks PENDING/PROCESSING/RETRYING rows as FAILED so a subsequent reparse
     * creates a fresh record. Safe to call when nothing is in-flight — returns
     * canceled=0 in that case.
     * @param clusterId
     * @param documentId
     * @returns any Successful Response
     * @throws ApiError
     */
    public cancelParse(
        clusterId: string,
        documentId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/document-parse/cancel-parse/{document_id}',
            path: {
                'cluster_id': clusterId,
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Retry Parse
     * Retry a failed document parse.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * parse_id: ID of the parse record to retry
     * parse_service: Document parse service
     *
     * Returns:
     * DocumentParseStatusResponse with updated status
     * @param clusterId
     * @param parseId
     * @returns DocumentParseStatusResponse Successful Response
     * @throws ApiError
     */
    public retryParse(
        clusterId: string,
        parseId: string,
    ): CancelablePromise<DocumentParseStatusResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/document-parse/retry-parse/{parse_id}',
            path: {
                'cluster_id': clusterId,
                'parse_id': parseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Parses For Cluster
     * List all document parses for a cluster.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * parse_service: DocumentParseService
     *
     * Returns:
     * List of DocumentParseStatusResponse
     * @param clusterId
     * @returns DocumentParseStatusResponse Successful Response
     * @throws ApiError
     */
    public listParsesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<DocumentParseStatusResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/document-parse/list-parses',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Download Parse Result
     * Download the parsed result file.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * parse_id: ID of the parse record
     * parse_service: DocumentParseService
     * file_service: FileService instance
     *
     * Returns:
     * Redirect to presigned download URL
     * @param clusterId
     * @param parseId
     * @returns any Successful Response
     * @throws ApiError
     */
    public downloadParseResult(
        clusterId: string,
        parseId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/document-parse/download-parse/{parse_id}',
            path: {
                'cluster_id': clusterId,
                'parse_id': parseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Parse Result
     * Get the parsed result data as JSON.
     *
     * This endpoint returns the parsed document data directly as JSON, automatically
     * handling gzip decompression if the stored result file is compressed.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * parse_id: ID of the parse record
     * parse_service: DocumentParseService
     *
     * Returns:
     * Parsed result data as JSON object:
     * - For Excel files: GridGrazerResponse format
     * - For other document types: format depends on the parse client used
     *
     * Raises:
     * 404: If parse record not found or the parse result not available
     * 500: If there's an error reading or decompressing the result file
     * @param clusterId
     * @param parseId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getParseResult(
        clusterId: string,
        parseId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/document-parse/parse-result/{parse_id}',
            path: {
                'cluster_id': clusterId,
                'parse_id': parseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Check Document Parse
     * Check if a document has a parse matching the specified criteria.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * document_id: ID of the document to check
     * parse_client: Optional specific parse client to check
     * sheets: Optional list of sheet names. If provided, only return parse that matches these sheets.
     * statuses: Optional list of statuses to filter by. If not provided, return any status.
     * parse_service: Optional specific parse client to check
     *
     * Returns:
     * DocumentParseStatusResponse if a matching parse exists, None otherwise
     * @param clusterId
     * @param documentId
     * @param sheets Optional list of sheet names to match. If not provided, returns any parse without sheet filtering.
     * @param statuses Optional list of statuses to filter by. If not provided, returns parses with any status. If provided, only returns parse with one of these statuses.
     * @param parseClient Specific parse client to check. If not provided, will determine based on current file type.
     * @returns any Successful Response
     * @throws ApiError
     */
    public checkDocumentParse(
        clusterId: string,
        documentId: string,
        sheets?: (Array<string> | null),
        statuses?: (Array<DocumentParseStatus> | null),
        parseClient?: (DocumentParseClientType | null),
    ): CancelablePromise<(DocumentParseStatusResponse | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/document-parse/check-parse/{document_id}',
            path: {
                'cluster_id': clusterId,
                'document_id': documentId,
            },
            query: {
                'sheets': sheets,
                'statuses': statuses,
                'parse_client': parseClient,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Parse Overrides
     * Save spreadsheet overrides for a parsed document.
     *
     * This endpoint saves user-modified spreadsheet metadata such as:
     * - Sheet visibility (hidden/visible)
     * - Frozen panes configuration
     * - Row/column visibility and dimensions
     *
     * The overrides are stored separately from the original parse result
     * and are applied when the parse result is retrieved.
     *
     * Args:
     * cluster_id: ID of the cluster (from route)
     * parse_id: ID of the parse record
     * overrides: Sheet overrides to save
     * parse_service: Optional specific parse client to save
     * override_service: Optional specific parse client to save
     *
     * Returns:
     * DocumentParseResponseFileOverrideRead with saved overrides
     *
     * Raises:
     * 404: If parse record not found or no response file exists
     * 400: If override validation fails
     * @param clusterId
     * @param parseId
     * @param requestBody
     * @returns DocumentParseResponseFileOverride Successful Response
     * @throws ApiError
     */
    public saveParseOverrides(
        clusterId: string,
        parseId: string,
        requestBody: SheetOverridesRequest,
    ): CancelablePromise<DocumentParseResponseFileOverride> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/document-parse/parse/{parse_id}/overrides',
            path: {
                'cluster_id': clusterId,
                'parse_id': parseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Global Text Search Results
     * @param clusterId
     * @param search
     * @returns PaginatedSearchResponse Successful Response
     * @throws ApiError
     */
    public listGlobalTextSearchResults(
        clusterId: string,
        search: string,
    ): CancelablePromise<PaginatedSearchResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/orchestration/global-search',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Recent Visit Metadata
     * @param clusterId
     * @param requestBody
     * @returns EnrichedVisitResponse Successful Response
     * @throws ApiError
     */
    public listRecentVisitMetadata(
        clusterId: string,
        requestBody: RecentVisitPayload,
    ): CancelablePromise<EnrichedVisitResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/recent-visit-metadata',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Validate Field Values For Field
     * Validate field values without saving them. Returns detailed validation results with normalized values.
     * @param clusterId
     * @param fieldId
     * @param asOfDate
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public validateFieldValuesForField(
        clusterId: string,
        fieldId: string,
        asOfDate: string,
        requestBody: UpdateFieldValuesPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/validate-field-values-for-field/{field_id}',
            path: {
                'cluster_id': clusterId,
                'field_id': fieldId,
            },
            query: {
                'as_of_date': asOfDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Field Values For Field
     * @param clusterId
     * @param fieldId
     * @param asOfDate
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public saveFieldValuesForField(
        clusterId: string,
        fieldId: string,
        asOfDate: string,
        requestBody: UpdateFieldValuesPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/save-field-values-for-field/{field_id}',
            path: {
                'cluster_id': clusterId,
                'field_id': fieldId,
            },
            query: {
                'as_of_date': asOfDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Assign Task Template
     * @param clusterId
     * @param entityId
     * @param taskTemplateId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public assignTaskTemplate(
        clusterId: string,
        entityId: string,
        taskTemplateId: string,
        requestBody: AssignTaskTemplatePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/assign-task-template',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'entity_id': entityId,
                'task_template_id': taskTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Assign Task Template
     * Bulk assign a task template to multiple entities with specific membership assignments.
     * @param clusterId
     * @param taskTemplateId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkAssignTaskTemplate(
        clusterId: string,
        taskTemplateId: string,
        requestBody: BulkAssignTaskTemplatePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/bulk-assign-task-template',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'task_template_id': taskTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add Cluster Membership
     * @param clusterId
     * @param requestBody
     * @returns MembershipRead Successful Response
     * @throws ApiError
     */
    public addClusterMembership(
        clusterId: string,
        requestBody: AddClusterMembershipPayload,
    ): CancelablePromise<MembershipRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/add-membership',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Entity
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns EntityRead Successful Response
     * @throws ApiError
     */
    public createEntity(
        clusterId: string,
        namespaceId: string,
        requestBody: AddEntity,
    ): CancelablePromise<EntityRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/create-entity',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Import Entities From File
     * Bulk import entities from file data (CSV, Excel) uploaded via the UI.
     *
     * This endpoint:
     * - Receives mapped data from the frontend ImportModal
     * - Resolves parent entity names to IDs
     * - Resolves reference field names to field IDs
     * - Creates entities using the orchestration service
     *
     * Args:
     * cluster_id: Cluster ID (from auth guard)
     * namespace_id: Target namespace for all entities
     * request: Import request containing data and options
     *
     * Returns:
     * ImportResult with status, counts, and any errors
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns ImportResult Successful Response
     * @throws ApiError
     */
    public importEntitiesFromFile(
        clusterId: string,
        namespaceId: string,
        requestBody: EntityFileImportRequest,
    ): CancelablePromise<ImportResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/namespaces/{namespace_id}/import-entities-from-file',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Resend Cluster Invitation
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public resendClusterInvitation(
        clusterId: string,
        requestBody: ResendInvitationPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/resend-cluster-invitation',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Filter Entities For Namespace
     * Filter entities for a namespace based on specified filters
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public filterEntitiesForNamespace(
        clusterId: string,
        namespaceId: string,
        requestBody: EntityFiltersPayload,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/filter-entities-for-namespace',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Sort Entities For Namespace
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public sortEntitiesForNamespace(
        clusterId: string,
        namespaceId: string,
        requestBody: EntitySortPayload,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/sort-entities-for-namespace',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Entities With Parents
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns EntityWithParents Successful Response
     * @throws ApiError
     */
    public listEntitiesWithParents(
        clusterId: string,
        namespaceId: string,
        requestBody?: (Array<EntityFilter> | null),
    ): CancelablePromise<Array<EntityWithParents>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/orchestration/list-entities-with-parents',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Databases For Cluster
     * @param clusterId
     * @returns DatabaseRead Successful Response
     * @throws ApiError
     */
    public listDatabasesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<DatabaseRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/databases/list-databases-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Database For Cluster
     * @param clusterId
     * @param databaseId
     * @returns DatabaseWithRowsAndColumns Successful Response
     * @throws ApiError
     */
    public getDatabaseForCluster(
        clusterId: string,
        databaseId: string,
    ): CancelablePromise<DatabaseWithRowsAndColumns> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/databases/get-database-for-cluster/{database_id}',
            path: {
                'cluster_id': clusterId,
                'database_id': databaseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Modify Database Schema
     * @param clusterId
     * @param databaseId
     * @param requestBody
     * @returns DatabaseWithRowsAndColumns Successful Response
     * @throws ApiError
     */
    public modifyDatabaseSchema(
        clusterId: string,
        databaseId: string,
        requestBody: ModifyDatabaseSchemaPayload,
    ): CancelablePromise<DatabaseWithRowsAndColumns> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/databases/modify-database-schema/{database_id}',
            path: {
                'cluster_id': clusterId,
                'database_id': databaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Rename Database
     * @param clusterId
     * @param databaseId
     * @param newName
     * @returns any Successful Response
     * @throws ApiError
     */
    public renameDatabase(
        clusterId: string,
        databaseId: string,
        newName: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/databases/rename-database/{database_id}',
            path: {
                'cluster_id': clusterId,
                'database_id': databaseId,
            },
            query: {
                'new_name': newName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Database
     * @param clusterId
     * @param databaseId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteDatabase(
        clusterId: string,
        databaseId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/databases/delete-database/{database_id}',
            path: {
                'cluster_id': clusterId,
                'database_id': databaseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Reports For Cluster
     * @param clusterId
     * @returns ReportRead Successful Response
     * @throws ApiError
     */
    public listReportsForCluster(
        clusterId: string,
    ): CancelablePromise<Array<ReportRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/reports/list-reports-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk List Report Instances
     * @param clusterId
     * @param requestBody
     * @returns ReportInstanceSummary Successful Response
     * @throws ApiError
     */
    public bulkListReportInstances(
        clusterId: string,
        requestBody: Array<string>,
    ): CancelablePromise<Record<string, Array<ReportInstanceSummary>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/reports/bulk-list-report-instances',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Report For Cluster
     * @param clusterId
     * @param requestBody
     * @returns ReportRead Successful Response
     * @throws ApiError
     */
    public createReportForCluster(
        clusterId: string,
        requestBody: ReportCreate,
    ): CancelablePromise<ReportRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/reports/create-report-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Report Fonts
     * @param clusterId
     * @returns ReportFontWithUrl Successful Response
     * @throws ApiError
     */
    public listReportFonts(
        clusterId: string,
    ): CancelablePromise<Array<ReportFontWithUrl>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/report-fonts/list-report-fonts',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Report Font
     * @param clusterId
     * @param requestBody
     * @returns ReportFontWithUrl Successful Response
     * @throws ApiError
     */
    public createReportFont(
        clusterId: string,
        requestBody: ReportFontCreate,
    ): CancelablePromise<ReportFontWithUrl> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/report-fonts/create-report-font',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Report Font
     * @param clusterId
     * @param fontId
     * @param requestBody
     * @returns ReportFontWithUrl Successful Response
     * @throws ApiError
     */
    public updateReportFont(
        clusterId: string,
        fontId: string,
        requestBody: ReportFontUpdate,
    ): CancelablePromise<ReportFontWithUrl> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/report-fonts/update-report-font/{font_id}',
            path: {
                'cluster_id': clusterId,
                'font_id': fontId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Report Font
     * @param clusterId
     * @param fontId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteReportFont(
        clusterId: string,
        fontId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/report-fonts/delete-report-font/{font_id}',
            path: {
                'cluster_id': clusterId,
                'font_id': fontId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Tracked Time Series Models For Cluster
     * @param clusterId
     * @returns TrackedTimeSeriesModelRead Successful Response
     * @throws ApiError
     */
    public listTrackedTimeSeriesModelsForCluster(
        clusterId: string,
    ): CancelablePromise<Array<TrackedTimeSeriesModelRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/tsm/list-tracked-time-series-models-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Time Series Model
     * @param clusterId
     * @param namespaceId
     * @param tsmId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateTimeSeriesModel(
        clusterId: string,
        namespaceId: string,
        tsmId: string,
        requestBody: TimeSeriesModelUpdatePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/tsm/update-time-series-model/{namespace_id}/{tsm_id}',
            path: {
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
                'tsm_id': tsmId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Member Entity Access For Cluster
     * @param clusterId
     * @returns MemberEntityAccess Successful Response
     * @throws ApiError
     */
    public listMemberEntityAccessForCluster(
        clusterId: string,
    ): CancelablePromise<Array<MemberEntityAccess>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/roles/list-member-entity-access',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Role Assignments For Cluster
     * @param clusterId
     * @param requestBody
     * @returns RoleAssignmentWarning Successful Response
     * @throws ApiError
     */
    public saveRoleAssignmentsForCluster(
        clusterId: string,
        requestBody: RoleAssignmentsCreatePayload,
    ): CancelablePromise<Array<RoleAssignmentWarning>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/roles/save-role-assignments-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Concept Contexts
     * List all AI concept contexts for a cluster.
     * @param clusterId
     * @returns AIConceptContextRead Successful Response
     * @throws ApiError
     */
    public listConceptContexts(
        clusterId: string,
    ): CancelablePromise<Array<AIConceptContextRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/ai-concepts/list-concept-contexts',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upsert Concept Context
     * Create or update context for an AI concept.
     * @param clusterId
     * @param requestBody
     * @returns AIConceptContextRead Successful Response
     * @throws ApiError
     */
    public upsertConceptContext(
        clusterId: string,
        requestBody: AIConceptContextUpsert,
    ): CancelablePromise<AIConceptContextRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/ai-concepts/upsert-concept-context',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Concept Context
     * Delete an AI concept context.
     * @param contextId
     * @param clusterId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteConceptContext(
        contextId: string,
        clusterId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/ai-concepts/delete-concept-context/{context_id}',
            path: {
                'context_id': contextId,
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Available Ai Concepts
     * Get list of all available AI concepts with their names and descriptions.
     * @param clusterId
     * @returns AIConceptInfo Successful Response
     * @throws ApiError
     */
    public listAvailableAiConcepts(
        clusterId: string,
    ): CancelablePromise<Array<AIConceptInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/ai-concepts/list-available-ai-concepts',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Chat With Chart Assistant
     * Chat with Lu's Chart Assistant.
     *
     * Uses the ChartAssistant AI agent to build and modify charts.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public chatWithChartAssistant(
        clusterId: string,
        requestBody: ChartAssistantPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/chart-assistant',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Cancel Chart Assistant
     * Cancel an in-progress chart assistant operation.
     *
     * Sets a cancellation flag in Redis that the task checks periodically.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public cancelChartAssistant(
        clusterId: string,
        requestBody: ChartAssistantCancelPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/cancel-chart-assistant',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Chat With Grid Assistant
     * Chat with Lu's Grid Assistant.
     *
     * Uses the GridAssistant AI agent to build and modify grids.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public chatWithGridAssistant(
        clusterId: string,
        requestBody: GridAssistantPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/grid-assistant',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Cancel Grid Assistant
     * Cancel an in-progress grid assistant operation.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public cancelGridAssistant(
        clusterId: string,
        requestBody: GridAssistantCancelPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/cancel-grid-assistant',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Dashboards For Cluster
     * @param clusterId
     * @returns DashboardRead Successful Response
     * @throws ApiError
     */
    public listDashboardsForCluster(
        clusterId: string,
    ): CancelablePromise<Array<DashboardRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/dashboards/list-dashboards-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List All Dashboards For Cluster
     * @param clusterId
     * @returns DashboardRead Successful Response
     * @throws ApiError
     */
    public listAllDashboardsForCluster(
        clusterId: string,
    ): CancelablePromise<Array<DashboardRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/dashboards/list-all-dashboards-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Namespace Dashboards For Cluster
     * @param clusterId
     * @param namespaceId
     * @returns DashboardRead Successful Response
     * @throws ApiError
     */
    public listNamespaceDashboardsForCluster(
        clusterId: string,
        namespaceId: string,
    ): CancelablePromise<Array<DashboardRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/dashboards/list-namespace-dashboards-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reorder Dashboards For Cluster
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderDashboardsForCluster(
        clusterId: string,
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/reorder-dashboards-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reorder Dashboards For Namespace
     * @param clusterId
     * @param namespaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderDashboardsForNamespace(
        clusterId: string,
        namespaceId: string,
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/reorder-dashboards-for-namespace',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Favorite Dashboards
     * List all favorited dashboards for the current user in this cluster.
     * @param clusterId
     * @param membershipId
     * @returns FavoriteDashboardSummary Successful Response
     * @throws ApiError
     */
    public listFavoriteDashboards(
        clusterId: string,
        membershipId: string,
    ): CancelablePromise<Array<FavoriteDashboardSummary>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/dashboards/list-favorite-dashboards',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'membership_id': membershipId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Dashboard For Cluster
     * @param clusterId
     * @param requestBody
     * @returns DashboardRead Successful Response
     * @throws ApiError
     */
    public createDashboardForCluster(
        clusterId: string,
        requestBody: RenderableDashboard,
    ): CancelablePromise<DashboardRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/create-dashboard-for-cluster',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Dashboard For Membership
     * @param clusterId
     * @param membershipId
     * @param requestBody
     * @returns DashboardRead Successful Response
     * @throws ApiError
     */
    public createDashboardForMembership(
        clusterId: string,
        membershipId: string,
        requestBody: RenderableDashboard,
    ): CancelablePromise<DashboardRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/create-dashboard-for-membership/{membership_id}',
            path: {
                'cluster_id': clusterId,
                'membership_id': membershipId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Render Dashboard
     * @param clusterId
     * @param effectiveDate
     * @param requestBody
     * @returns RenderedDashboard Successful Response
     * @throws ApiError
     */
    public renderDashboard(
        clusterId: string,
        effectiveDate: string,
        requestBody: RenderableDashboard,
    ): CancelablePromise<RenderedDashboard> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/render-dashboard/{effective_date}',
            path: {
                'cluster_id': clusterId,
                'effective_date': effectiveDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Traceback For Dashboard Renderable
     * @param clusterId
     * @param requestBody
     * @param relativeToDate
     * @param isInterpolated
     * @param widgetEffectiveDate
     * @returns Traceback Successful Response
     * @throws ApiError
     */
    public tracebackForDashboardRenderable(
        clusterId: string,
        requestBody: RenderableTracebackCell,
        relativeToDate?: (string | null),
        isInterpolated: boolean = true,
        widgetEffectiveDate?: (string | null),
    ): CancelablePromise<Traceback> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/traceback-for-dashboard-renderable',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'relative_to_date': relativeToDate,
                'is_interpolated': isInterpolated,
                'widget_effective_date': widgetEffectiveDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Traceback For View Renderable
     * Traceback for view-based widgets (tables, charts, etc.)
     * @param clusterId
     * @param requestBody
     * @param relativeToDate
     * @param isInterpolated
     * @returns Traceback Successful Response
     * @throws ApiError
     */
    public tracebackForViewRenderable(
        clusterId: string,
        requestBody: RenderableTracebackCell,
        relativeToDate?: (string | null),
        isInterpolated: boolean = true,
    ): CancelablePromise<Traceback> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/dashboards/traceback-for-view-renderable',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'relative_to_date': relativeToDate,
                'is_interpolated': isInterpolated,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Data Extraction Overview
     * @param clusterId
     * @returns DataExtractionOverview Successful Response
     * @throws ApiError
     */
    public getDataExtractionOverview(
        clusterId: string,
    ): CancelablePromise<DataExtractionOverview> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/data-extraction/get-data-extraction-overview',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Previous Lens Captures For Lens Ids
     * @param clusterId
     * @param dataExtractionId
     * @param maximumEffectiveDate
     * @param requestBody
     * @returns LensCaptureRead Successful Response
     * @throws ApiError
     */
    public listPreviousLensCapturesForLensIds(
        clusterId: string,
        dataExtractionId: string,
        maximumEffectiveDate: (string | null),
        requestBody: Array<string>,
    ): CancelablePromise<Array<LensCaptureRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/data-extraction/list-previous-lens-captures-for-lens_ids/{data_extraction_id}',
            path: {
                'cluster_id': clusterId,
                'data_extraction_id': dataExtractionId,
            },
            query: {
                'maximum_effective_date': maximumEffectiveDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Copy Rich Text Block
     * @param clusterId
     * @param requestBody
     * @returns CopiedRichTextResponse Successful Response
     * @throws ApiError
     */
    public copyRichTextBlock(
        clusterId: string,
        requestBody: CopiedRichTextPayload,
    ): CancelablePromise<CopiedRichTextResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/data-extraction/copy-rich-text-block',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Time Entry
     * Create a new time entry.
     * @param clusterId
     * @param requestBody
     * @returns TimeEntryRead Successful Response
     * @throws ApiError
     */
    public createTimeEntry(
        clusterId: string,
        requestBody: TimeEntryCreate,
    ): CancelablePromise<TimeEntryRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/monitoring/create-time-entry',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Create Time Entries
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkCreateTimeEntries(
        clusterId: string,
        requestBody: BulkCreateTimeEntriesPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/monitoring/bulk-create-time-entries',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Time Entry
     * Delete a time entry.
     * @param timeEntryId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteTimeEntry(
        timeEntryId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/monitoring/delete-time-entry/{time_entry_id}',
            path: {
                'time_entry_id': timeEntryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Time Entries For Activity
     * List time entries with optional filtering.
     * @param clusterId
     * @param activityId
     * @returns TimeEntryWithDetails Successful Response
     * @throws ApiError
     */
    public listTimeEntriesForActivity(
        clusterId: string,
        activityId: string,
    ): CancelablePromise<Array<TimeEntryWithDetails>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/monitoring/list-time-entries-for-activity',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Total Time Spent For Activity
     * @param clusterId
     * @param activityId
     * @returns number Successful Response
     * @throws ApiError
     */
    public getTotalTimeSpentForActivity(
        clusterId: string,
        activityId: string,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/monitoring/get-total-time-spent-for-activity',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Cashflow Ledger
     * Create a new cashflow ledger for a cluster.
     * @param clusterId
     * @param requestBody
     * @returns CashflowLedgerRead Successful Response
     * @throws ApiError
     */
    public createCashflowLedger(
        clusterId: string,
        requestBody: CashflowLedgerCreateRequest,
    ): CancelablePromise<CashflowLedgerRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/create-cashflow-ledger',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflow Ledgers For Cluster
     * List all cashflow ledgers for a cluster.
     * @param clusterId
     * @returns CashflowLedgerRead Successful Response
     * @throws ApiError
     */
    public listCashflowLedgersForCluster(
        clusterId: string,
    ): CancelablePromise<Array<CashflowLedgerRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/list-cashflow-ledgers',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Ledger Association Coverage
     * Per-namespace entity-association coverage for a cashflow ledger.
     * @param clusterId
     * @param ledgerId
     * @returns NamespaceCoverage Successful Response
     * @throws ApiError
     */
    public getLedgerAssociationCoverage(
        clusterId: string,
        ledgerId: string,
    ): CancelablePromise<Array<NamespaceCoverage>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/association-coverage',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflow Transaction Types For Cluster
     * List all cashflow transaction types for a cluster.
     * @param clusterId
     * @returns CashflowTransactionTypeRead Successful Response
     * @throws ApiError
     */
    public listCashflowTransactionTypesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<CashflowTransactionTypeRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/list-cashflow-transaction-types',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Cashflow Transaction Type
     * Create a new cashflow transaction type.
     * @param clusterId
     * @param requestBody
     * @returns CashflowTransactionTypeRead Successful Response
     * @throws ApiError
     */
    public createCashflowTransactionType(
        clusterId: string,
        requestBody: CashflowTransactionTypeCreate,
    ): CancelablePromise<CashflowTransactionTypeRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/create-cashflow-transaction-type',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflow Scenarios For Cluster
     * List all cashflow scenarios for a cluster.
     * @param clusterId
     * @returns CashflowScenarioRead Successful Response
     * @throws ApiError
     */
    public listCashflowScenariosForCluster(
        clusterId: string,
    ): CancelablePromise<Array<CashflowScenarioRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/list-cashflow-scenarios',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Cashflow Scenario
     * Create a new cashflow scenario.
     * @param clusterId
     * @param requestBody
     * @returns CashflowScenarioRead Successful Response
     * @throws ApiError
     */
    public createCashflowScenario(
        clusterId: string,
        requestBody: CashflowScenarioCreate,
    ): CancelablePromise<CashflowScenarioRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/create-cashflow-scenario',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflow Tag Categories For Cluster
     * List all cashflow tag categories for a cluster.
     * @param clusterId
     * @returns CashflowTagCategoryRead Successful Response
     * @throws ApiError
     */
    public listCashflowTagCategoriesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<CashflowTagCategoryRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/list-cashflow-tag-categories',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Cashflow Tag Category
     * Create a new cashflow tag category with initial tag values.
     * @param clusterId
     * @param requestBody
     * @returns CashflowTagCategoryRead Successful Response
     * @throws ApiError
     */
    public createCashflowTagCategory(
        clusterId: string,
        requestBody: CashflowTagCategoryCreateWithValues,
    ): CancelablePromise<CashflowTagCategoryRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/create-cashflow-tag-category',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflow External Identifier Types For Cluster
     * List all cashflow external identifier types for a cluster with ledger usage information.
     * @param clusterId
     * @returns CashflowExternalIdentifierTypeWithLedgers Successful Response
     * @throws ApiError
     */
    public listCashflowExternalIdentifierTypesForCluster(
        clusterId: string,
    ): CancelablePromise<Array<CashflowExternalIdentifierTypeWithLedgers>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/list-cashflow-external-identifier-types',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Cashflow External Identifier Type
     * Create a new cashflow external identifier type with ledger associations.
     * @param clusterId
     * @param requestBody
     * @returns CashflowExternalIdentifierTypeWithLedgers Successful Response
     * @throws ApiError
     */
    public createCashflowExternalIdentifierType(
        clusterId: string,
        requestBody: CashflowExternalIdentifierTypeMutate,
    ): CancelablePromise<CashflowExternalIdentifierTypeWithLedgers> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/create-cashflow-external-identifier-type',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cashflow Import Fields
     * Get field definitions for cashflow imports.
     *
     * This endpoint provides the schema for the import modal:
     * - Core cashflow fields (amount, date, entity, etc.)
     * - Dynamic tag categories for this cluster
     * - Dynamic external identifier types for this cluster
     *
     * Frontend uses this to build the field mapping UI dynamically.
     *
     * Returns:
     * List of field definitions with keys, labels, types, and requirements
     * @param clusterId
     * @param ledgerId
     * @returns FieldDefinition Successful Response
     * @throws ApiError
     */
    public getCashflowImportFields(
        clusterId: string,
        ledgerId: string,
    ): CancelablePromise<Array<FieldDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/import/fields',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Import Cashflows From File
     * Import cashflows from file data (CSV, Excel) uploaded via the UI.
     *
     * This endpoint:
     * - Receives mapped data from the frontend ImportModal
     * - Uses generic importer for field-level validation
     * - Delegates to existing cashflow importer for complex logic
     *
     * Args:
     * cluster_id: Cluster ID (from auth guard)
     * ledger_id: Target ledger for cashflows
     * request: Import request containing data and options
     *
     * Returns:
     * ImportResult with status, counts, and any errors
     * @param clusterId
     * @param ledgerId
     * @param requestBody
     * @returns ImportResult Successful Response
     * @throws ApiError
     */
    public importCashflowsFromFile(
        clusterId: string,
        ledgerId: string,
        requestBody: CashflowFileImportRequest,
    ): CancelablePromise<ImportResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/import-from-file',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Export Columns
     * Get available columns for cashflow ledger export configuration.
     *
     * Returns core columns (fixed) plus dynamic columns based on ledger configuration:
     * - Tag categories: Columns for each tag category defined in the cluster
     * - External identifiers: Columns for each external ID type associated with the ledger
     * @param clusterId
     * @param ledgerId
     * @returns CashflowExportColumnsResponse Successful Response
     * @throws ApiError
     */
    public getExportColumns(
        clusterId: string,
        ledgerId: string,
    ): CancelablePromise<CashflowExportColumnsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/export/columns',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Cashflows To Excel
     * Export cashflows from a ledger to an Excel file.
     *
     * The exported file is compatible with the import format, enabling round-trip workflows:
     * download → edit externally → re-import with upsert.
     *
     * Features:
     * - Column headers match import field labels exactly
     * - Includes Cashflow ID column to enable upsert via match_using="lumonic_id"
     * - Tags exported as semicolon-delimited strings
     * - Dates formatted as YYYY-MM-DD
     * - Transaction Type and Scenario use names (not IDs)
     * - Optional column, entity, scenario, and property-based filtering
     *
     * Args:
     * cluster_id: Cluster ID (from auth guard)
     * ledger_id: The ledger to export cashflows from
     * request: Export configuration with optional column, entity, and scenario filters.
     *
     * Returns:
     * Response containing presigned URL for downloading the Excel file (expires in 1 hour)
     * @param clusterId
     * @param ledgerId
     * @param requestBody
     * @returns CashflowExportResponse Successful Response
     * @throws ApiError
     */
    public exportCashflowsToExcel(
        clusterId: string,
        ledgerId: string,
        requestBody?: CashflowExportRequest,
    ): CancelablePromise<CashflowExportResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/export',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Export Templates
     * List all export templates for a ledger, sorted pinned-first then newest.
     * @param clusterId
     * @param ledgerId
     * @returns CashflowExportTemplateRead Successful Response
     * @throws ApiError
     */
    public listExportTemplates(
        clusterId: string,
        ledgerId: string,
    ): CancelablePromise<Array<CashflowExportTemplateRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/export-templates',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Export Template
     * Create a new export template for a ledger.
     * @param clusterId
     * @param ledgerId
     * @param requestBody
     * @returns CashflowExportTemplateRead Successful Response
     * @throws ApiError
     */
    public createExportTemplate(
        clusterId: string,
        ledgerId: string,
        requestBody: CashflowExportTemplateCreate,
    ): CancelablePromise<CashflowExportTemplateRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/cashflows/ledgers/{ledger_id}/export-templates',
            path: {
                'cluster_id': clusterId,
                'ledger_id': ledgerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Setup Cluster Ingestion
     * Provision file ingestion and email a one-time credential link to the client (staff only).
     * @param clusterId
     * @param requestBody
     * @returns IngestionCredentialLinkResponse Successful Response
     * @throws ApiError
     */
    public setupClusterIngestion(
        clusterId: string,
        requestBody: IngestionSetupRequest,
    ): CancelablePromise<IngestionCredentialLinkResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/setup',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Rotate Ingestion Credentials
     * Rotate IAM access key and email new credentials to the client (staff only).
     * @param clusterId
     * @param requestBody
     * @returns IngestionCredentialLinkResponse Successful Response
     * @throws ApiError
     */
    public rotateIngestionCredentials(
        clusterId: string,
        requestBody: IngestionSetupRequest,
    ): CancelablePromise<IngestionCredentialLinkResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/rotate-credentials',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Tenant Config For Cluster
     * Get the ingestion configuration for a cluster.
     * @param clusterId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getTenantConfigForCluster(
        clusterId: string,
    ): CancelablePromise<(IngestionTenantConfigRead | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/file-ingestion/tenant-config',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Tenant Config
     * Update an existing tenant ingestion configuration.
     * @param clusterId
     * @param configId
     * @param requestBody
     * @returns IngestionTenantConfigRead Successful Response
     * @throws ApiError
     */
    public updateTenantConfig(
        clusterId: string,
        configId: string,
        requestBody: IngestionTenantConfigUpdate,
    ): CancelablePromise<IngestionTenantConfigRead> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/file-ingestion/tenant-config/{config_id}',
            path: {
                'cluster_id': clusterId,
                'config_id': configId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Folder Mappings
     * List all folder → entity mappings for a cluster.
     * @param clusterId
     * @returns IngestionFolderMappingRead Successful Response
     * @throws ApiError
     */
    public listFolderMappings(
        clusterId: string,
    ): CancelablePromise<Array<IngestionFolderMappingRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/file-ingestion/folder-mappings',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Folder Mapping
     * Create a new folder → entity mapping.
     * @param clusterId
     * @param requestBody
     * @returns IngestionFolderMappingRead Successful Response
     * @throws ApiError
     */
    public createFolderMapping(
        clusterId: string,
        requestBody: IngestionFolderMappingCreate,
    ): CancelablePromise<IngestionFolderMappingRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/folder-mappings',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Folder Mapping
     * Update an existing folder mapping.
     * @param clusterId
     * @param mappingId
     * @param requestBody
     * @returns IngestionFolderMappingRead Successful Response
     * @throws ApiError
     */
    public updateFolderMapping(
        clusterId: string,
        mappingId: string,
        requestBody: IngestionFolderMappingUpdate,
    ): CancelablePromise<IngestionFolderMappingRead> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/file-ingestion/folder-mappings/{mapping_id}',
            path: {
                'cluster_id': clusterId,
                'mapping_id': mappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Folder Mapping
     * Delete a folder mapping.
     * @param clusterId
     * @param mappingId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteFolderMapping(
        clusterId: string,
        mappingId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/file-ingestion/folder-mappings/{mapping_id}',
            path: {
                'cluster_id': clusterId,
                'mapping_id': mappingId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Folder Tree
     * Browse folders in the ingestion S3 bucket.
     *
     * Returns immediate child folders at the given prefix level with mapping info.
     * Used by the Folder Explorer UI for lazy-loading tree navigation.
     * @param clusterId
     * @param prefix Relative path prefix for lazy-loading subfolders
     * @returns FolderTreeNode Successful Response
     * @throws ApiError
     */
    public getFolderTree(
        clusterId: string,
        prefix: string = '',
    ): CancelablePromise<Array<FolderTreeNode>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/file-ingestion/folder-tree',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'prefix': prefix,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Tag Mappings
     * List all subfolder → document tag mappings for a cluster.
     * @param clusterId
     * @returns IngestionTagMappingRead Successful Response
     * @throws ApiError
     */
    public listTagMappings(
        clusterId: string,
    ): CancelablePromise<Array<IngestionTagMappingRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/file-ingestion/tag-mappings',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Tag Mapping
     * Create a new subfolder → document tag mapping.
     * @param clusterId
     * @param requestBody
     * @returns IngestionTagMappingRead Successful Response
     * @throws ApiError
     */
    public createTagMapping(
        clusterId: string,
        requestBody: IngestionTagMappingCreate,
    ): CancelablePromise<IngestionTagMappingRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/tag-mappings',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Tag Mapping
     * Update an existing tag mapping.
     * @param clusterId
     * @param mappingId
     * @param requestBody
     * @returns IngestionTagMappingRead Successful Response
     * @throws ApiError
     */
    public updateTagMapping(
        clusterId: string,
        mappingId: string,
        requestBody: IngestionTagMappingUpdate,
    ): CancelablePromise<IngestionTagMappingRead> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clusters/{cluster_id}/file-ingestion/tag-mappings/{mapping_id}',
            path: {
                'cluster_id': clusterId,
                'mapping_id': mappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Tag Mapping
     * Delete a tag mapping.
     * @param clusterId
     * @param mappingId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteTagMapping(
        clusterId: string,
        mappingId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/file-ingestion/tag-mappings/{mapping_id}',
            path: {
                'cluster_id': clusterId,
                'mapping_id': mappingId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Ingestion History
     * Query ingestion history for a cluster.
     * @param clusterId
     * @param requestBody
     * @returns IngestionRecordRead Successful Response
     * @throws ApiError
     */
    public listIngestionHistory(
        clusterId: string,
        requestBody: IngestionHistoryQuery,
    ): CancelablePromise<Array<IngestionRecordRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/history',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Ingestion Stats
     * Get count of records by status for a cluster.
     * @param clusterId
     * @returns number Successful Response
     * @throws ApiError
     */
    public getIngestionStats(
        clusterId: string,
    ): CancelablePromise<Record<string, number>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/file-ingestion/history/stats',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Retry All Ingestion Records
     * Queue retry tasks for failed/quarantined records matching the given filters.
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public retryAllIngestionRecords(
        clusterId: string,
        requestBody?: RetryAllQuery,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/history/retry-all',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Retry Ingestion Record
     * Retry a failed or quarantined ingestion record (synchronous).
     * @param clusterId
     * @param recordId
     * @returns IngestionRecordRead Successful Response
     * @throws ApiError
     */
    public retryIngestionRecord(
        clusterId: string,
        recordId: string,
    ): CancelablePromise<IngestionRecordRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/file-ingestion/history/{record_id}/retry',
            path: {
                'cluster_id': clusterId,
                'record_id': recordId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Inbox For Cluster
     * @param clusterId
     * @param statusFilter
     * @returns InboundEmailInboxResponse Successful Response
     * @throws ApiError
     */
    public listInboxForCluster(
        clusterId: string,
        statusFilter: InboundEmailInboxFilter,
    ): CancelablePromise<InboundEmailInboxResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/inbound-emails',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'status_filter': statusFilter,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Count Pending For Cluster
     * @param clusterId
     * @returns InboundEmailPendingCountResponse Successful Response
     * @throws ApiError
     */
    public countPendingForCluster(
        clusterId: string,
    ): CancelablePromise<InboundEmailPendingCountResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/inbound-emails/pending-count',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Accept Attachments For Cluster
     * @param clusterId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public bulkAcceptAttachmentsForCluster(
        clusterId: string,
        requestBody: BulkAcceptInboundAttachmentRequest,
    ): CancelablePromise<Array<InboundEmailAttachmentRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/bulk-accept',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Ignore Attachments For Cluster
     * @param clusterId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public bulkIgnoreAttachmentsForCluster(
        clusterId: string,
        requestBody: BulkIgnoreInboundAttachmentRequest,
    ): CancelablePromise<Array<InboundEmailAttachmentRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/bulk-ignore',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Attachment Download Url For Cluster
     * @param clusterId
     * @param attachmentId
     * @returns FileWithUrl_Output Successful Response
     * @throws ApiError
     */
    public getAttachmentDownloadUrlForCluster(
        clusterId: string,
        attachmentId: string,
    ): CancelablePromise<FileWithUrl_Output> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/inbound-emails/attachments/{attachment_id}/download-url',
            path: {
                'cluster_id': clusterId,
                'attachment_id': attachmentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Accept Attachment For Cluster
     * @param clusterId
     * @param attachmentId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public acceptAttachmentForCluster(
        clusterId: string,
        attachmentId: string,
        requestBody: AcceptInboundAttachmentRequest,
    ): CancelablePromise<InboundEmailAttachmentRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/attachments/{attachment_id}/accept',
            path: {
                'cluster_id': clusterId,
                'attachment_id': attachmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Ignore Attachment For Cluster
     * @param clusterId
     * @param attachmentId
     * @param requestBody
     * @returns InboundEmailAttachmentRead Successful Response
     * @throws ApiError
     */
    public ignoreAttachmentForCluster(
        clusterId: string,
        attachmentId: string,
        requestBody: IgnoreInboundAttachmentRequest,
    ): CancelablePromise<InboundEmailAttachmentRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/inbound-emails/attachments/{attachment_id}/ignore',
            path: {
                'cluster_id': clusterId,
                'attachment_id': attachmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
